import { ENV } from '../../config/runtimeEnv';

export const API_BASE_URL = ENV.VITE_NOTIFICATION_BASE_URL;
import type {
	ScheduledNotification,
	CreateScheduledNotificationRequest,
	BulkScheduleRequest,
	ScheduledNotificationStats,
	ScheduledNotificationFilters,
} from '../../types/communications/NotificationTypes';
import { createServiceClient } from '../../lib/http/client';

const createApiInstance = () => {
	return createServiceClient({
		baseURL: API_BASE_URL,
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

export const fetchScheduledNotifications = async (filters?: ScheduledNotificationFilters): Promise<{ data: ScheduledNotification[] }> => {
	try {
		const api = createApiInstance();
		const response = await api.get('/scheduled-notifications', {
			params: filters,
		});
		return response.data;
	} catch (error) {
		console.error('Error fetching scheduled notifications:', error);
		throw error;
	}
};

export const fetchScheduledNotification = async (id: number): Promise<ScheduledNotification> => {
	try {
		const api = createApiInstance();
		const response = await api.get<ScheduledNotification>(`/scheduled-notifications/${id}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching scheduled notification:', error);
		throw error;
	}
};

export const createScheduledNotification = async (data: CreateScheduledNotificationRequest): Promise<{ message: string; data: ScheduledNotification }> => {
	try {
		const api = createApiInstance();
		const response = await api.post('/scheduled-notifications', data);
		return response.data;
	} catch (error) {
		console.error('Error creating scheduled notification:', error);
		throw error;
	}
};

export const bulkScheduleNotifications = async (data: BulkScheduleRequest): Promise<{ message: string; data: ScheduledNotification[]; count: number }> => {
	try {
		const api = createApiInstance();
		const response = await api.post('/scheduled-notifications/bulk', data);
		return response.data;
	} catch (error) {
		console.error('Error bulk scheduling notifications:', error);
		throw error;
	}
};

export const cancelScheduledNotification = async (id: number): Promise<{ message: string; data: ScheduledNotification }> => {
	try {
		const api = createApiInstance();
		const response = await api.delete(`/scheduled-notifications/${id}`);
		return response.data;
	} catch (error) {
		console.error('Error cancelling scheduled notification:', error);
		throw error;
	}
};

export const cancelByEntity = async (entityType: string, entityId: string): Promise<{ message: string; count: number }> => {
	try {
		const api = createApiInstance();
		const response = await api.post('/scheduled-notifications/cancel-by-entity', {
			related_entity_type: entityType,
			related_entity_id: entityId,
		});
		return response.data;
	} catch (error) {
		console.error('Error cancelling notifications by entity:', error);
		throw error;
	}
};

export const fetchScheduledNotificationStats = async (companyId?: number): Promise<ScheduledNotificationStats> => {
	try {
		const api = createApiInstance();
		const response = await api.get<ScheduledNotificationStats>('/scheduled-notifications/stats', {
			params: companyId ? { company_id: companyId } : undefined,
		});
		return response.data;
	} catch (error) {
		console.error('Error fetching scheduled notification stats:', error);
		throw error;
	}
};